import {Message} from 'iview'

function addCart () { // 加入购物车
    console.log(addCart)
    return 'addCart'
}

function min (item, minorderunit, minordernum, matrixing, sign) { // 减少数量
    let moq
    let num = item.num
    item.unitshow ? moq = (minorderunit != 'maxunit' ? Math.ceil(parseInt(minordernum) / parseInt(matrixing)) : minordernum) : moq = minordernum
    if (sign == 'gwc') {
        if (num <= moq) {
            num = moq
            Message.warning('不能小于起订量')
        } else {
            num--
        }
    } else {
        num <= moq ? num = 0 : num--
    }
    return num
}

function add (item, cxinfo, stock, minorderunit, minordernum, matrixing, maxunit, unit, outstock) { // 增加数量
    /**
     * nums 购买数量
     * moq 起订量
     * stocks 库存
     * personcountx 促销每人限领
     * availableamount 促销总数量
     * is_limit_personcount 个人促销是否限量 0 不限  1 限量 
     * is_limit_amount 个人促销是否限量 0 不限  1 限量 
     */
    // 数量
    let nums = item.num
    // 起订量，库存，促销每人限领，促销总数量
    let moq, stocks, personcountx, availableamount
    
    if (item.unitshow) {
        moq = (minorderunit != 'maxunit' ? Math.ceil(parseInt(minordernum) / parseInt(matrixing)) : minordernum)
        stocks = Math.floor(parseInt(stock) / parseInt(matrixing))
        personcountx = Math.floor(parseInt(cxinfo.personcountx) / parseInt(matrixing))
        availableamount = Math.floor(parseInt(cxinfo.availableamount) / parseInt(matrixing))
    } else {
        moq = minordernum
        stocks = stock
        personcountx = cxinfo.personcountx
        availableamount = cxinfo.availableamount
    }

    // 是否是促销商品，数量是否大于
    if (cxinfo.is_cx == 1 && nums >= personcountx && cxinfo.is_limit_personcount == 1 || cxinfo.is_cx == 1 && nums >= availableamount && cxinfo.is_limit_amount == 1) { // 促销限量
        if (parseInt(nums) >= parseInt(availableamount) && cxinfo.is_limit_amount == 1) {
            nums = parseInt(availableamount)
            Message.warning('促销数量剩余' + availableamount + (item.unitshow ? maxunit : unit))
        } else if (parseInt(nums) >= parseInt(personcountx) && cxinfo.is_limit_personcount == 1) {
            nums = parseInt(personcountx)
            Message.warning('每人限领' + personcountx + (item.unitshow ? maxunit : unit))
        } else if (parseInt(personcountx) > 0 && nums >= personcountx) {
            nums = parseInt(personcountx)
            Message.warning('本次活动限量购买' + personcountx + (item.unitshow ? maxunit : unit))
        } else if (item.stock < availableamount && outstock <= 0) {
            nums = parseInt(item.stock)
            Message.warning('库存为' + availableamount + (item.unitshow ? maxunit : unit) + ',不可超库存下单')
        }
    } else if (nums >= stocks && outstock <= 0) { // 是否大于库存 <=0 no
        nums = parseInt(stocks)
        Message.warning('库存为' + stocks + (item.unitshow ? maxunit : unit) + ',不可超库存下单')
    } else if (nums < moq) {
        nums = parseInt(moq)
    } else {
        nums++
    }
    
    return nums
}

function unitChange (item, cxinfo, stock, minorderunit, minordernum, matrixing, maxunit, unit, doubleunit, outstock) { // 改变大小单位

        let params = {
            nums: item.num, // 商品数量
            unitshows: item.unitshow, // 当前大&小单位
        }

        // 双单位并且后台设置为小单位时允许切换大小单位
        if (doubleunit == 2 && minorderunit == 'unit') params.unitshows = !params.unitshows

        // 起订量，库存， 促销每人限领， 促销总数量
        let moq, stocks, personcountx, availableamount
        
        if (params.unitshows) {
            moq = (minorderunit != 'maxunit' ? Math.ceil(parseInt(minordernum) / parseInt(matrixing)) : minordernum)
            stocks = Math.floor(parseInt(stock) / parseInt(matrixing))
            personcountx = Math.floor(parseInt(cxinfo.personcountx) / parseInt(matrixing))
            availableamount = Math.floor(parseInt(cxinfo.availableamount) / parseInt(matrixing))
        } else {
            moq = minordernum
            stocks = stock
            personcountx = cxinfo.personcountx
            availableamount = cxinfo.availableamount
        }
        
        // 是否是促销商品，数量是否大于
        if (params.nums > 0) {
            if (cxinfo.is_cx == 1 && params.nums >= personcountx && cxinfo.is_limit_personcount == 1 || cxinfo.is_cx == 1 && params.nums >= availableamount && cxinfo.is_limit_personcount == 1) { // 促销限量
                if (parseInt(nums) >= parseInt(availableamount) && cxinfo.is_limit_amount == 1) {
                    params.nums = parseInt(availableamount)
                    Message.warning('促销数量剩余' + availableamount + (params.unitshows ? maxunit : unit))
                } else if (parseInt(nums) >= parseInt(personcountx) && cxinfo.is_limit_personcount == 1) {
                    nums = parseInt(personcountx)
                    Message.warning('每人限领' + personcountx + (item.unitshow ? maxunit : unit))
                } else if (parseInt(personcountx) > 0 && params.nums >= personcountx) {
                    params.nums = parseInt(personcountx)
                    Message.warning('本次活动限量购买' + personcountx + (params.unitshows ? maxunit : unit))
                } else if (item.stock < availableamount && outstock <= 0) {
                    params.nums = parseInt(item.stock)
                    Message.warning('库存为' + availableamount + (params.unitshows ? maxunit : unit) + ',不可超库存下单')
                }
            } else if (params.nums >= stocks && outstock <= 0) { // 是否大于库存 <=0 no
                params.nums = parseInt(stocks)
                Message.warning('库存为' + stocks + (params.unitshows ? maxunit : unit) + ',不可超库存下单')
            } else if (params.nums >= moq) {
                return params
            } else {
                params.nums = parseInt(moq)
            }
        }
        return params
}

function numBlur (item, cxinfo, stock, minorderunit, minordernum, matrixing, maxunit, unit, outstock) { // 修改输入框内的数值
    // 数量
    let nums = item.num
    // 起订量，库存，促销每人限领，促销总数量
    let moq, stocks, personcountx, availableamount
    
    if (item.unitshow) {
        moq = (minorderunit != 'maxunit' ? Math.ceil(parseInt(minordernum) / parseInt(matrixing)) : minordernum)
        stocks = Math.floor(parseInt(stock) / parseInt(matrixing))
        personcountx = Math.floor(parseInt(cxinfo.personcountx) / parseInt(matrixing))
        availableamount = Math.floor(parseInt(cxinfo.availableamount) / parseInt(matrixing))
    } else {
        moq = minordernum
        stocks = stock
        personcountx = cxinfo.personcountx
        availableamount = cxinfo.availableamount
    }

    // 是否是促销商品，数量是否大于
    if (cxinfo.is_cx == 1 && nums >= personcountx && cxinfo.is_limit_personcount == 1 || cxinfo.is_cx == 1 && nums >= availableamount && cxinfo.is_limit_amount == 1) { // 促销限量
        if (parseInt(nums) >= parseInt(availableamount) && cxinfo.is_limit_amount == 1) {
            nums = parseInt(availableamount)
            Message.warning('促销数量剩余' + availableamount + (item.unitshow ? maxunit : unit))
        } else if (parseInt(nums) >= parseInt(personcountx) && cxinfo.is_limit_personcount == 1) {
            nums = parseInt(personcountx)
            Message.warning('每人限领' + personcountx + (item.unitshow ? maxunit : unit))
        } else if (parseInt(personcountx) > 0 && nums >= personcountx) {
            nums = parseInt(personcountx)
            Message.warning('本次活动限量购买' + personcountx + (item.unitshow ? maxunit : unit))
        } else if (item.stock < availableamount && outstock <= 0) {
            nums = parseInt(item.stock)
            Message.warning('库存为' + availableamount + (item.unitshow ? maxunit : unit) + ',不可超库存下单')
        }
    } else if (nums >= stocks && outstock <= 0) { // 是否大于库存 <=0 no
        nums = parseInt(stocks)
        Message.warning('库存为' + stocks + (item.unitshow ? maxunit : unit) + ',不可超库存下单')
    } else if (nums > 0 && nums < moq) {
        nums = parseInt(moq)
    }
    
    return nums
}

export {
    addCart, add, min, unitChange, numBlur
}


// WEBPACK FOOTER //
// ./src/assets/js/addcart.js